import api from "../../axiosConfig";

export const addInvestigationGroups = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('investigation-groups/add-update', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'error adding investigation group');
    }
  };


export const getInvestigationGroup = async (doctor_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/investigation-groups/all', {
      params: {
        doctor_id:doctor_id
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching investigation group');
  }
};

export const updateInvestigationGroups = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/nvestigation-groups/add-update/`, payload
    );

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating investigation group');
  }
};
